import React from 'react';
import { observer } from 'mobx-react';
import { Separator } from 'react-contexify';
var ContextMenuSeparatorImplementation = function () {
    return (React.createElement(Separator, null));
};
export default observer(ContextMenuSeparatorImplementation);
//# sourceMappingURL=ContextMenuSeparatorImplementation.js.map